import { Result } from '@standardnotes/domain-core';
export class IsVaultOwner {
    constructor(users) {
        this.users = users;
    }
    execute(vault) {
        if (!vault.sharing) {
            return Result.ok(true);
        }
        if (!vault.sharing.ownerUserUuid) {
            throw new Error(`Shared vault ${vault.sharing.sharedVaultUuid} does not have an owner user uuid`);
        }
        const user = this.users.sureUser;
        return Result.ok(vault.sharing.ownerUserUuid === user.uuid);
    }
}
